import { Api, ApiResponse } from './api';

export type UserLoginResponse = {
    result: boolean;
    error: string|null;
    username: string|null;
    userid: number;
}

export type UserTokenResponse = {
    expires: number;
    token: string;
}

export type UserCSRFResponse = {
    name: string;
    value: string;
}

export type UserResetResponse = {
    data: object;
    msg: string;
    message: 'username-required'|'reset-sent';
    messageType?: 'danger'|'success';
    result: boolean;
    error: string;
}

export class UserApi {
    constructor(public readonly url: string, private readonly api: typeof Api) {}

    async login(data: {username: string, [key: string]: unknown}) {
        // using fetch, as api_post would get a token
        const response = await fetch(`${this.url}/api/auth/login`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({ 'Content-Type': 'application/json', Accept: 'application/json' }),
        });
        const json = await response.json();
        return json as ApiResponse<UserLoginResponse>;
    }

    async token() {
        // using fetch, as api_post would get a token
        const response = await fetch(`${this.url}/api/auth/token`, {
            method: 'POST',
            body: null,
            headers: new Headers({ 'Content-Type': 'application/json', Accept: 'application/json' }),
        });
        const json = await response.json();
        return json as ApiResponse<UserTokenResponse>;
    }

    async csrf() {
        return Api.api_get<UserCSRFResponse>(`${this.url}/api/auth/csrf`);
    }

    async strategies(username: string) {
        return Api.api_get<string[]>(`${this.url}/api/auth/strategy?username=${username}`);
    }

    async reset(usernameOrEmail: string) {
        return Api.api_post<UserResetResponse>(`${this.url}/api/auth/reset`, { username: usernameOrEmail });
    }

    /**
     * not implemented
     */
    async totp_qrcode() {}

    async totp_validate(otp: number, credential: string) {
        return Api.api_post<'otp validated'>(`${this.url}/api/auth/totp_validate`, { otp, credential });
    }

    async status() {
        return Api.api_get<{username: string}>(`${this.url}/api/auth/status`);
    }

    /**
     * not implemented
     */
    async email_test() {}
}
